import { render } from "./ProfileFriendContent.vue?vue&type=template&id=6570291c&scoped=true"
import script from "./ProfileFriendContent.vue?vue&type=script&lang=js"
export * from "./ProfileFriendContent.vue?vue&type=script&lang=js"

import "./ProfileFriendContent.vue?vue&type=style&index=0&id=6570291c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6570291c"]])

export default __exports__